import { IPlano } from "../Data/Interfaces/Request/Plano/IPlano";

export class PlanosHelper {
  static getPlanoVal = (
    plano: IPlano,
    interval_type: string,
    showIntervalType: boolean = true,
    multiplicarValorPor: number = 1
  ): string => {
    let valor = 0;
    const planValor = (plano.value_cents / 100) * multiplicarValorPor;

    let interval_type_name = "";

    switch (interval_type) {
      case "months":
        switch (multiplicarValorPor) {
          case 1:
            interval_type_name = "mês";
            break;
          case 3:
            interval_type_name = "trimestral";
            break;
          case 6:
            interval_type_name = "semestral";
            break;
          case 12:
            interval_type_name = "ano";
            break;
          default:
            interval_type_name = `a cada ${multiplicarValorPor} meses`;
            break;
        }
        if (plano.interval_type === "months") {
          valor = planValor / plano.interval;
        } else if (plano.interval_type === "weeks") {
          valor = planValor * 4.345;
        }
        break;
      case "year":
        if (plano.interval === 12) {
          valor = planValor;
        } else if (plano.interval_type === "months") {
          valor = (planValor / plano.interval) * 12;
        } else if (plano.interval_type === "weeks") {
          valor = planValor * 4.345 * 12;
        }
        interval_type_name = "ano";
        break;
      default:
        break;
    }

    return `${valor.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    })}${showIntervalType ? "/" + interval_type_name : ""}`;
  };
}
